module.exports = __webpack_public_path__ + "img/1.9971bd40.png";